import { map } from 'lodash';

interface NewLineTextProps {
  text: string;
}

const NewLineText = ({ text }: NewLineTextProps): JSX.Element => {
  const splitText = text.split('\n');
  return (
      <>
        {map(splitText, (line, index) => {
          return (
              <span key={`line-${line}-${index}`}>
            <div dangerouslySetInnerHTML={{__html: line}} />
                {index !== splitText.length - 1 && <div style={{height:'0.25rem'}} />}
          </span>
          );
        })}
      </>
  );
};

export default NewLineText;
